import { ConfigStrings, ErrorCodes } from 'src/app/utils/common-classes';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../Auth/auth.service";
export class TreeService {
    constructor(httpClient, authService) {
        this.httpClient = httpClient;
        this.authService = authService;
    }
    getTrees() {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.get(ConfigStrings.API_URL + "/get-trees", { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
}
TreeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TreeService_Factory() { return new TreeService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: TreeService, providedIn: "root" });
